import React, { useState } from "react";
import styles from "./style.module.css";
import star from "../../images/star.svg";
import { NavLink } from "react-router-dom";

const Playlist = ({ data }) => {
  const text = data.description;

  const [readMore, setReadMore] = useState(true);

  return (
    <div className={styles.container}>
      <div className={styles.img}>
        <NavLink
          to={
            "/creator/" +
            data?.creator?.name +
            "/" +
            data?.language +
            "/" +
            data?.name +
            "/" +
            data?._id
          }
        >
          <img
            src={
              data?.videos[0]?.thumbnail
                ? data?.videos[0]?.thumbnail
                : "http://res.cloudinary.com/artistry/image/upload/v1647319076/category_images/gliyfkyy7hpegwklrfdq.png"
            }
            alt=""
          />{" "}
        </NavLink>
      </div>{" "}
      <div className={styles.main}>
        <div className={styles.top}>
          <NavLink
            to={
              "/creator/" +
              data?.creator?.name +
              "/" +
              data?.language +
              "/" +
              data?.name +
              "/" +
              data?._id
            }
          >
            <h3 className={styles.title}>{data?.name}</h3>{" "}
          </NavLink>
          <div className="flex items-center justify-center space-x-1">
            <div className={styles.rating}>
              {isNaN(Number(data.avgRating).toFixed(1))
                ? 0
                : Number(data.avgRating).toFixed(1)}
            </div>
            <div className="rating   rating-sm rating-half">
              {Array.from({ length: 10 }).map((_, index) => {
                return (
                  <div key={index}>
                    <input
                      disabled
                      type="radio"
                      name="rating-10"
                      className={
                        "mask mask-star-2 " +
                        (index % 2 === 0 ? " mask-half-1 " : " mask-half-2 ") +
                        (index / 2 <
                          Math.round(parseFloat(data.avgRating) * 2) / 2 &&
                          " bg-amber-500 ")
                      }
                    />
                  </div>
                );
              })}
            </div>
            {/* <img src={star} alt="" className={styles.star} /> */}
            <div>
              {" "}
              {"("}
              {data.feedbacks?.length}
              {")"}
            </div>
          </div>
        </div>

        <p className={styles.desc}>
          {readMore ? text?.slice(0, 50) : text}
          {text?.length > 70 && (
            <>
              ...
              <button
                onClick={() => setReadMore(!readMore)}
                style={{ fontWeight: "bold" }}
              >
                {readMore ? (
                  <span className={styles.readMore}>readmore</span>
                ) : (
                  <span className={styles.readMore}>show less</span>
                )}
              </button>
            </>
          )}
        </p>

        <div className={styles.subcat}>
          <p>{data.category.name}&#62;</p>
          <p>{data.language}</p>
          <div className={styles.rateboi}>
            <span className={styles.rating}>
              {isNaN(Number(data.avgRating).toFixed(1))
                ? 0
                : Number(data.avgRating).toFixed(1)}
              /5
            </span>
            <img src={star} alt="" className={styles.star} />
          </div>
        </div>

        <p className={styles.author}>By {data?.creator?.name}</p>
      </div>
    </div>
  );
};

export default Playlist;
